import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getMedicalForms, reviewMedicalForm } from 'lib/supabaseQueries';
import { useAuthContext } from 'context/authContext';

const EMPTY_ARRAY = [];

export function useMedicalForms() {
  const { organization, isInitialized } = useAuthContext();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['medicalForms', organization?.id],
    queryFn: () => getMedicalForms(organization.id),
    enabled: isInitialized && !!organization?.id
  });
  return {
    forms: data?.data || EMPTY_ARRAY,
    isLoading,
    error: error || data?.error,
    refetch
  };
}

export function useReviewMedicalForm() {
  const queryClient = useQueryClient();
  const { user } = useAuthContext();
  const mutation = useMutation({
    mutationFn: async ({ id, status, adminNotes }) => {
      const result = await reviewMedicalForm(id, {
        status,
        adminNotes,
        userId: user?.id
      });
      if (result.error) throw new Error(result.error);
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['medicalForms'] });
      toast.success('Form updated');
    },
    onError: () => toast.error('Failed to update form')
  });
  return {
    review: mutation.mutate,
    isReviewing: mutation.isPending
  };
}
